var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exclamation-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99984 19.1833C14.6022 19.1833 18.3332 15.4523 18.3332 10.8499C18.3332 6.2476 14.6022 2.5166 9.99984 2.5166C5.3975 2.5166 1.6665 6.24752 1.6665 10.8499C1.6665 15.4524 5.3975 19.1833 9.99984 19.1833ZM9.1665 6.68327C9.1665 6.22269 9.53967 5.84994 9.99984 5.84994C10.46 5.84994 10.8332 6.22269 10.8332 6.68327V11.6833C10.8332 12.1439 10.46 12.5166 9.99984 12.5166C9.53967 12.5166 9.1665 12.1439 9.1665 11.6833V6.68327ZM9.99984 14.1833C10.4601 14.1833 10.8332 14.5564 10.8332 15.0166C10.8332 15.4769 10.4601 15.8499 9.99984 15.8499C9.53959 15.8499 9.1665 15.4768 9.1665 15.0166C9.1665 14.5564 9.53959 14.1833 9.99984 14.1833Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorFeedback);
export default __webpack_public_path__ + "static/media/errorFeedback.e109f013a0ef3d4e9782bc1218a2a104.svg";
export { ForwardRef as ReactComponent };